import ReferralContentContainer from './ReferralContentContainer';

export default ReferralContentContainer;
